import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { URL_KEYS, RequestUrl } from './request-url.service';
import { ToastService } from '../services/toast.service';

@Injectable()
export class ApiRequestService {

  constructor(private httpClient: HttpClient, private toasterService: ToastService) { }


  get(url: URL_KEYS, query = '', headers?, passRespType = false) {
    return new Promise((resolve, reject) => {
      console.log('in GET function');
      const reqUrlOptions = RequestUrl.get(url);
      const options: {
        headers?: HttpHeaders,
        params?: HttpParams,
        reportProgress?: boolean,
        responseType: any,
        withCredentials?: boolean
      } = {
        headers,
        responseType: passRespType ? 'blob' : 'json',
      };
      options['observe'] = 'response';
      console.log(reqUrlOptions.url + `${query}`);
      this.httpClient.get(reqUrlOptions.url + `${query}`, options).subscribe((response) => {
        resolve(this.handleResponse(response, reqUrlOptions));
      }, (error) => {
        console.log(error);
        reject(error);
      });
    });

  }

  post(url: URL_KEYS, body, headers?) {
    console.log(headers)
    return new Promise((resolve, reject) => {
      console.log('in POST function');
      const reqUrlOptions = RequestUrl.get(url);
      console.log(reqUrlOptions);
      console.log('Jimit', body);
      console.log('Jimit', headers)
      this.httpClient.post(reqUrlOptions.url, body, { observe: 'response', headers }).subscribe((response) => {
        console.log('Inside PUT response');
        resolve(this.handleResponse(response, reqUrlOptions));
      }, (error) => {
        console.log(error);
        reject(error);
      });
    });
  }

  put(url: URL_KEYS, body, headers?) {
    return new Promise((resolve, reject) => {
      console.log('in PUT function');
      const reqUrlOptions = RequestUrl.get(url);
      return this.httpClient.put(reqUrlOptions.url, body, { observe: 'response', headers }).subscribe((response) => {
        resolve(this.handleResponse(response, reqUrlOptions));
      }, (error) => {
        console.log(error);
        reject(error);
      });
    });
  }

  async handleResponse(response, reqUrlOptions) {
    console.log('Inside Handle REsponse');
    if (Math.floor(response['status'] / 100) === 2 && reqUrlOptions.showMsg) {
      console.log('HttpResponse::event =', response, ';');
      await this.toasterService.presentToast(response['body']['message'], 'Success', 'success');
    } else {
      console.log('event =', response, ';');
    }
    return response;
  }
}
